/**
 * 退款申请入口
 */
import React, { FC, useMemo } from 'react'
import { classNames, ddayjs, toPrice } from '@dt/fe-utils'
import { Icon } from '@cps'
import { useHistoryNew } from '@utils'
import { TEOrdersRefundStatus, TEOrdersType } from '@common/enum/order.enum'
import { find } from '@dt/fe-utils/dist/lodash'
import { observer } from 'mobx-react'
import './index.scss'

interface IProps {
  info: any;
}

const RefundBar: FC<IProps> = ({ info }) => {
  const history = useHistoryNew()
  const refundInfo = info.ordersRefundList?.[info.ordersRefundList?.length - 1]
  const refundStatus = refundInfo && refundInfo?.status

  const refundDesc = useMemo(() => {
    if (!refundInfo || !info) return
    let rejectInfo = find((info.extList || []), (item) => item.attrName === 'rejectMessage')
    switch (refundStatus) {
      case TEOrdersRefundStatus.Success:
        return i18n.t(`refund.statusDesc.${TEOrdersRefundStatus.Success}`)
      case TEOrdersRefundStatus.Reject:
        return i18n.t(`refund.statusDesc.${TEOrdersRefundStatus.Reject}`, { reason: rejectInfo.attrValue })
      case TEOrdersRefundStatus.Timeout:
        return i18n.t(`refund.statusDesc.${TEOrdersRefundStatus.Timeout}`)
      default:
        return i18n.t(`refund.statusDesc.${TEOrdersRefundStatus.Pending}`, { date: ddayjs(refundInfo?.addTime).add(24, 'hour').format('YYYY-MM-DD HH:mm') })
    }
  }, [info])
  const handleToRefund = () => {
    history.replace(`/refund/detail/${info.ordersId}`)
  }
  /** 未退款不展示, pos直接退的也不展示 */
  /** TODO 231212 周厨确认手机发起的没有deviceId，可以从deviceId === null 判断是手机 */
  if (info.ordersType !== TEOrdersType.dc || !info.refundTime || !refundInfo || !Object.values(TEOrdersRefundStatus).includes(refundInfo?.status) || refundInfo?.deviceId) return null
  return (
    <div className='refund-bar-container'>
      <div className='refund-status-wrapper' data-cypid='refund-bar-btn' onClick={handleToRefund}>
        <div className='refund-price'>{i18n.t('refund.refundRequest')} {toPrice(info.paidFee)}</div>
        <div className='refund-status'>
          <span className={classNames('refund-txt', { error: [TEOrdersRefundStatus.Timeout, TEOrdersRefundStatus.Reject].includes(refundInfo.status) })}>{i18n.t(`refund.status.${refundInfo.status}`)}</span>
          <Icon name='chevron-right' />
        </div>
      </div>
      <div className='refund-status-desc'>{refundDesc}</div>
    </div>
  )
}

export default observer(RefundBar)
